// Czy zalogowane konto ma dostęp do API (konta Scientii); backend: AccessController
import axios from "axios";
import { ApiURI } from "../types/configs";
import { headers } from "./headers";

export interface AccessInfo {
  email: string | null;
  allowed: boolean;
  enforced: boolean; // false = backend tylko loguje konta spoza domen (Access:Mode=Log)
  isAdmin?: boolean; // rola admina z Users (starszy backend: brak pola = nie admin)
}

export const fetchAccess = async (): Promise<AccessInfo> =>
  (await axios.get<AccessInfo>(ApiURI + "Access/me", headers())).data;

// Komunikat „brak dostępu” tylko przy włączonej blokadzie (w trybie Log aplikacja działa normalnie)
export const isBlocked = (a: AccessInfo | null | undefined) => !!a && !a.allowed && a.enforced;
